export default {
  container: {
    position: 'relative',
    minHeight: '100vh',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  pageWrapper: {
    py: ['0px', '0px'],
  },
  menuContainer: {
    width: '100%',
    display: ['flex', 'none'],
    height: ['40px', 'auto'],
    backgroundColor: ['rgba(15, 32,75, 0.5)', 'transparent'],
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'fixed',
    top: ['0', '40px'],
    zIndex: 4,
  },
  hiddenMenuContainer: {
    width: '100%',
    display: ['flex', 'none'],
    height: ['40px', 'auto'],
    backgroundColor: ['rgba(15, 32,75, 0.5)', 'transparent'],
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'fixed',
    zIndex: 4,
    top: '-80px',
    transition: '0.2s linear',
  },
  logo: {
    cursor: 'pointer',
    width: '60px',
    height: '40px',
    pt: '5px',
  },
}
